import { render, staticRenderFns } from "./settingChartOfAccount.vue?vue&type=template&id=4a29820c&scoped=true&"
import script from "./settingChartOfAccount.vue?vue&type=script&lang=js&"
export * from "./settingChartOfAccount.vue?vue&type=script&lang=js&"
import style0 from "./settingChartOfAccount.vue?vue&type=style&index=0&id=4a29820c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a29820c",
  null
  
)

export default component.exports